import { NavigationGuard, Route } from 'vue-router';

import { GuardResolveFunction } from '../models';

const executeGuard = (guardsList: NavigationGuard[], index: number, to: Route, from: Route, next: GuardResolveFunction): void => {
  const guard = guardsList[index];
  guard(to, from, (nextArg: any): void => {
    if ((nextArg !== undefined) || (index === (guardsList.length - 1))) {
      next(nextArg);
    } else {
      executeGuard(guardsList, (index + 1), to, from, next);
    }
  });
};

/**
 * This function encapsulates the execution of a list of guards under a single one signature, skipping the limit of ONE guard per route
 */
export const GUARDS_EXECUTOR = (guardsList: NavigationGuard[]): NavigationGuard => {
  return (to: Route, from: Route, next: GuardResolveFunction) => {
    executeGuard(guardsList, 0, to, from, next);
  };
};
